import * as http from '~/utils/apis';

const authApi = {
    getCsrf: async () => {
        try {
            await http.get('sanctum/csrf-cookie');
        } catch (error) {
            console.log(error);
        }
    },

    apiLogin: async ({ email, password }) => {
        let res = await http.post('cms-api/login', {
            email,
            password,
        });
        return res;
    },

    apiLogout: async () => {
        await http.post('cms-api/logout');
    },

    retrievePassword: async () => {
        await http.post('cms-api/password-retrieval');
    },
};

export default authApi;
